import NotFoundView from "./NotFound.view";

export default function LoginContainer() {
    return (
        <>
            <NotFoundView />
        </>
    );
}
